import AppConfig from '../config';

const API_URL = AppConfig.API_URL;

export const getImageUrl = (path) => {
    return `${API_URL}/${path}`
};



// WEBPACK FOOTER //
// ./helpers/helpers.js